"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EllipsisIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const EllipsisIcon = (props) => {
    return ((0, jsx_runtime_1.jsx)("svg", { ...props.svgProps, viewBox: "0 0 448 512", children: (0, jsx_runtime_1.jsx)("path", { fill: props.fill, d: "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z" }) }));
};
exports.EllipsisIcon = EllipsisIcon;
